import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";
import { contentStyles } from "modules/storyblok/adapters/Content";

export const textStyles: RichtextAdapterProps["customStyles"] = {
  ...contentStyles,
  paragraph: { ...contentStyles.paragraph, fontSize: "lg", color: "primary.900" },
};
